// The legal pages, served at /legal/:slug (SPEC §8).
import type { JSX } from "react";
import { Cookies } from "./Cookies";
import { Imprint } from "./Imprint";
import { LEGAL_NAV, type LegalSlug } from "./LegalLayout";
import { Licence } from "./Licence";
import { Privacy } from "./Privacy";
import { Terms } from "./Terms";

const COMPONENTS: Record<LegalSlug, () => JSX.Element> = {
  imprint: Imprint,
  privacy: Privacy,
  terms: Terms,
  licence: Licence,
  cookies: Cookies,
};

export const LEGAL_PAGES: { slug: LegalSlug; title: string; Component: () => JSX.Element }[] = LEGAL_NAV.map((p) => ({
  ...p,
  Component: COMPONENTS[p.slug],
}));

export type { LegalSlug };
